import { temAcesso } from '@/shared/auth/temAcesso'

const Contratacoes = () => import('./Contratacoes.vue')
const Contratacao = () => import('./Contratacao.vue')
const Entrega = () => import('./../entregas/Entrega.vue')

export default {
    path: 'contratacoes',
    name: 'Gerentes_Contratacoes',
    component: Contratacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-GER-CONT-00')) {
            next()
        }
    },
    children: [
        {
            path: ':contratacaoId',
            name: 'Gerentes_Contratacoes_Detalhar',
            component: Contratacao,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CRED-GER-CONT-01')) {
                    next()
                }
            },
            children: [
                {
                    path: 'entregas/:entregaId',
                    name: 'Gerentes_Entregas_Detalhar2',
                    component: Entrega,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('CRED-GER-ENTR-00')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
